const ContactForm = () => {
  return (
    <div>
      <iframe
        src="http://igfeed.seansaliva.com/blog/50-2/"
        title="Contact Form"
        width={1366}
        height={800}
      ></iframe>
    </div>
  );
};

export default ContactForm;
